"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigResource = void 0;
const jsonUtils_1 = require("benjibooks-shared/utils/jsonUtils");
const groupBy_1 = __importDefault(require("lodash/groupBy"));
const uniq_1 = __importDefault(require("lodash/uniq"));
const ConfigItem_1 = require("./ConfigItem");
/**
 * Resource defined in the config file.
 */
class ConfigResource {
    /**
     * Constructor.
     */
    constructor(config) {
        /** id of the resource. Used in URLs. */
        this.id = "";
        this.floor = "";
        this.building = "";
        this.color = "#000000";
        /** First possible time slot of each day that is displayed. */
        this.minTime = "06:00";
        /** Last possible time slot of each day that is displayed. */
        this.maxTime = "24:00";
        /** Available business hours. */
        this.businessHours = [];
        /** Number of minutes that should be empty between bookings. */
        this.breakBetweenBookings = 0;
        /** All addon items that can be used with this resource. */
        this.addonItems = [];
        /** If true, the resource is visible for public bookings. Default is true. */
        this.visible = true;
        this._config = config;
    }
    /**
     * Constructs an object of this class from the specified JSON-compatible dictionary object.
     */
    static fromJSON(json, config) {
        const obj = new ConfigResource(config);
        Object.assign(obj, json);
        // Overwrite fields that need converting.
        if ((0, jsonUtils_1.isJSONObject)(json.resourceItem)) {
            obj.resourceItem = ConfigItem_1.ConfigItem.fromJSON(json.resourceItem, config.defaultResourceUnits, config);
        }
        else {
            throw new Error("Config does not contain a valid 'resourceItem'");
        }
        if ((0, jsonUtils_1.isJSONObjectArray)(json.addonItems)) {
            obj.addonItems = json.addonItems.map((addon) => ConfigItem_1.ConfigItem.fromJSON(addon, config.defaultAddonUnits, config));
        }
        return obj;
    }
    /**
     * Converts this object to JSON-compatible dictionary object.
     * All fields from `this` will be in the returned object except the `undefined` values.
     */
    toJSON() {
        const json = (0, jsonUtils_1.toJSONWithFilters)(this, {
            filterUndefined: true,
            filterUnderscore: true, // _config
        });
        // Overwrite fields that need converting.
        json.resourceItem = this.resourceItem.toJSON();
        json.addonItems = this.addonItems.map((addon) => addon.toJSON());
        return json;
    }
    /** Is used for generating keys in multi select. */
    toString() {
        return this.id;
    }
    /**
     * Returns all possible addon types.
     */
    getAddonTypes({ includeHidden = false, includeMisc = false, } = {}) {
        const items = includeHidden ? this.addonItems : this.getVisibleAddonItems();
        const types = (0, uniq_1.default)(items.map((item) => item.type)).sort();
        if (includeMisc) {
            types.push(this._config.miscAddonType);
        }
        return types;
    }
    /**
     * Returns the addons grouped by type property.
     *
     * The sort order of the groups is according to the order in the addons array.
     */
    getAddonsGroupedByType({ includeHidden = false, } = {}) {
        const items = includeHidden ? this.addonItems : this.getVisibleAddonItems();
        return (0, groupBy_1.default)(items, (item) => item.type);
    }
    getVisibleAddonItems() {
        return this.addonItems.filter((item) => item.visible);
    }
}
exports.ConfigResource = ConfigResource;
